"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
  IconActivity,
  IconBuilding,
  IconCreditCard,
  IconDashboard,
  IconFileText,
  IconScroll,
  IconTags,
  IconUsers,
} from "@/components/icons";

type IconComponent = (props: { size?: number; className?: string }) => React.JSX.Element;

const NAV: { href: string; label: string; Icon: IconComponent }[] = [
  { href: "/dashboard",        label: "Tableau de bord",     Icon: IconDashboard },
  { href: "/tenants",          label: "Tenants",             Icon: IconBuilding },
  { href: "/billing",          label: "Abonnements",         Icon: IconCreditCard },
  { href: "/plans",            label: "Plans",               Icon: IconTags },
  { href: "/techniciens",      label: "Techniciens",         Icon: IconUsers },
  { href: "/report-templates", label: "Templates rapports",  Icon: IconFileText },
  { href: "/monitoring",       label: "Monitoring",          Icon: IconActivity },
  { href: "/activites",        label: "Journal",             Icon: IconScroll },
];

export function BottomDock() {
  const pathname = usePathname();

  return (
    <nav className="mf-dock" aria-label="Navigation principale">
      <div className="mf-dock__inner">
        {NAV.map(({ href, label, Icon }) => {
          const active =
            pathname === href || pathname.startsWith(href + "/");
          return (
            <Link
              key={href}
              href={href}
              className={`mf-dock__item ${active ? "mf-dock__item--active" : ""}`}
              aria-current={active ? "page" : undefined}
            >
              <span className="mf-dock__icon">
                <Icon size={22} />
              </span>
              <span className="mf-dock__label">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
